import { CleanContent } from './ui';


export default function StandardCta() {
  return (
    <CleanContent><section className="bg-blue py-5 text-center">
        <div className="container">
          <div className="eyebrow light mb-2">The SELECTEZI Standard</div>
          <h2 className="h-lg mb-2 text-white">Build Reputation<br />Create Opportunity</h2>
          <p className="p-md mx-auto mb-4" style={{ maxWidth: 560 }}>
            Build your enterprise standing on SELECTEZI. Earn your Star Rank through verifiable operational details, genuine customer evaluations, and consistent performance.
          </p>
          <a href="#create" className="btn btn-white px-4 fw-semibold">Claim Your Showcase Profile</a>
        </div>
      </section></CleanContent>
  );
}
